import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {numberFormat} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {getCurrency} from "../../utils/get_currency";
import type {IPropertyDetail} from "../types/IPropertyDetail";

interface IProps {
    property: IPropertyDetail;
}

export const _PropertyHighlightPriceM2 = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const currency = getCurrency({currency: props.property.offer.currency});

    return (
        <div className={m2PriceStyleWrapper}>
            <Text as="span" variant={isMobile ? "body_copy_2" : "info_txt_2"} color="white">
                {numberFormat(props.property.price_m2 as number)}&nbsp;
            </Text>
            <Text as="span" variant={isMobile ? "body_copy_2" : "info_txt_2"} color="white">
                {currency}/m2
            </Text>
        </div>
    );
};

const m2PriceStyleWrapper = css({
    paddingX: 1,
    paddingY: 1,
    backgroundColor: "var(--colors-secondary)",
    display: "flex",
    borderRadius: 0.5,
    flexDirection: "row"
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {numberFormat} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {getCurrency} from "../../utils/get_currency";
import type {IPropertyDetail} from "../types/IPropertyDetail";

interface IProps {
    property: IPropertyDetail;
}

export const _PropertyHighlightPriceM2 = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const currency = getCurrency({currency: props.property.offer.currency});

    return (
        <div className={m2PriceStyleWrapper}>
            <Text as="span" variant={isMobile ? "body_copy_2" : "info_txt_2"} color="white">
                {numberFormat(props.property.price_m2 as number)}&nbsp;
            </Text>
            <Text as="span" variant={isMobile ? "body_copy_2" : "info_txt_2"} color="white">
                {currency}/m2
            </Text>
        </div>
    );
};

const m2PriceStyleWrapper = css({
    paddingX: 1,
    paddingY: 1,
    backgroundColor: "var(--colors-secondary)",
    display: "flex",
    borderRadius: 0.5,
    flexDirection: "row"
});
